import { render, staticRenderFns } from "./MediumShow.vue?vue&type=template&id=5a7a92e8&"
import script from "./MediumShow.vue?vue&type=script&lang=js&"
export * from "./MediumShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports